/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Discounts {
    'use strict';

    class ProductFilterModalController {

        static $inject = [
            'productFilter',
            '$mdDialog',
        ];

        constructor(
            public productFilter: IProductFilter,
            protected $mdDialog: angular.material.IDialogService
        ) {
        }

        public cancel() {
            this.$mdDialog.cancel();
        }

        public clear() {
            this.productFilter = {
                manufacturers: [],
                productCategories: [],
            };
            this.$mdDialog.hide(this.productFilter);
        }

        public ok() {
            this.$mdDialog.hide(this.productFilter);
        }
    }

    angular.module('meevo.plugins.discounts')
        .controller('meevo.plugins.discounts.ProductFilterModalController', ProductFilterModalController);
}